import React from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const problemsWeSolve = [
  {
    title: "Reduces Administrative Burden",
    description:
      "Teachers and school staff spend less time on paperwork and repetitive administrative tasks. This saved time is redirected toward what matters most — spending more quality time with students.",
  },
  {
    title: "Provides Insightful Analytics for Focused Learning",
    description:
      "Smart analytics track student activity and performance, helping educators and parents identify strengths and areas for improvement. This leads to more personalized, focused learning experiences for each child.",
  },
  {
    title: "Boosts Parental Participation",
    description:
      "With real-time activity tracking, progress reports, and event updates, parents stay involved and informed. The application fosters stronger home-school collaboration, which is vital in the Montessori approach.",
  },
  {
    title: "Ensures Quality Lesson Delivery",
    description:
      "Preloaded lesson plans aligned with Montessori methodology help teachers deliver consistent, high-quality lessons. This supports both experienced and new educators in maintaining the Montessori integrity.",
  },
  {
    title: "Empowers Teachers with Ongoing Learning",
    description:
      "Built-in refresher modules and updates keep teachers aligned with best practices, enabling continuous professional growth and confidence in the classroom.",
  },
  {
    title: "Brings a Sense of Organization",
    description:
      "User-friendly dashboards and daily schedules allow educators and administrators to feel organized with minimal effort, reducing stress and improving classroom rhythm.",
  },
];

export default function ProblemsWeSolve() {
  return (
    <Container style={{ paddingTop: 30, paddingBottom: 30 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Why Choose Our Application?
      </Typography>
      <Typography variant="subtitle1" align="center" gutterBottom>
        How Our Montessori Application Solves Everyday Challenges
      </Typography>
      <br></br>
      <Grid container spacing={4}>
        {problemsWeSolve.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              style={{
                height: "100%",
                backgroundColor: "#f0f9ff",
                borderLeft: "5px solid #0f3b62",
              }}
            >
              <CardContent>
                <Typography variant="h6" style={{ color: "#0f3b62" }}>
                  <CheckCircleIcon
                    style={{
                      verticalAlign: "middle",
                      marginRight: 8,
                      color: "#0f3b62",
                    }}
                  />
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
